import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { AdminService } from "../admin.service";
import { apiUrl } from "src/app/global/global";

@Injectable({
  providedIn: "root"
})
export class LastStepperService {

  private lastStepperSubject = new BehaviorSubject<any>(null);
  lastStepperObserver: Observable<any> = this.lastStepperSubject.asObservable();

  constructor(private api: AdminService) {
    this.api.getDatas(apiUrl._getLastStepper)
      .subscribe(async (res) => this.lastStepperSubject.next(res.data));
  }
}
